import React from 'react'
import theme from 'theme'

const DashboardCollapse = ({ color = theme.colors.gray5 }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="ICO/24/Dashboard-Collapse">
      <path
        id="Vector 1044"
        d="M10 2L12 4L14 2"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector 1045"
        d="M10 22L12 20L14 22"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        id="Rectangle 1138"
        x="3"
        y="7"
        width="18"
        height="10"
        rx="2"
        stroke={color}
        strokeWidth="2"
      />
    </g>
  </svg>
)

export default DashboardCollapse
